class BasicTerrain {
    constructor(obj) {
        return {
            url: obj.url === undefined ? obj : obj.url,
            requestVertexNormals: obj.requestVertexNormals === undefined ? false : obj.requestVertexNormals,
            requestWaterMask: obj.requestWaterMask === undefined ? false : obj.requestWaterMask,
            ellipsoid: obj.ellipsoid === undefined ? map3d_viewer.viewer.scene.globe.ellipsoid : obj.ellipsoid,
            credit: obj.credit ? obj.credit : 'otherStaff'
        }
    }
}

class AddBar {
    constructor() {
        this.containers = []
        this.num = 3000
        this.level = 16
        this.hasLight = false
    }
    addBar() {
        const dr = new map3d.DrawTemplete.DrawRectangle({
            opacity: 0.3,
            color: "#ffffff",
            onSuccess: (rect) => {
                dr.clear()
                dr.endEvent()
                map3d_viewer.viewer.mouseHandlerManager.trigger("receiveMsg", null);
                const r = [rect.position[0], rect.position[1], rect.position[2], rect.position[3]]
                setTimeout(() => {
                    this.start(r)
                }, 500)
            }
        })
        dr.start()
        if (!this.hasLight) {
            this.hasLight = true
            let directionlightconfig = {
                //灯光颜色
                color: `rgba(5,5,5,0.6)`,
                //照射强度
                intensity: 16.6,
                //光源中心位置,格式为[lng,lat,height]
                lightcenter: [108.9436222741495, 34.37911617966134, 0],
                //目标中心位置,格式为[lng,lat,height]
                targetcenter: [108.92819379452489, 34.140058876636786, 0],
                debug: false,
            };
            new map3d.THREEEffect.DirectionLight(directionlightconfig);
            let directionlightconfig2 = {
                //灯光颜色
                color: `rgba(5,5,5,0.6)`,
                //照射强度
                intensity: 16.6,
                //光源中心位置,格式为[lng,lat,height]
                lightcenter: [108.92819379452489, 34.140058876636786, 0],
                //目标中心位置,格式为[lng,lat,height]
                targetcenter: [108.9436222741495, 34.37911617966134, 0],
                debug: false,
            };
            new map3d.THREEEffect.DirectionLight(directionlightconfig2);
            let directionlightconfig3 = {
                //灯光颜色
                color: `rgba(5,5,5,0.6)`,
                //照射强度
                intensity: 16.6,
                //光源中心位置,格式为[lng,lat,height]
                lightcenter: [108.7836134451926, 34.264255091601676, 0],
                //目标中心位置,格式为[lng,lat,height]
                targetcenter: [109.0763491865336, 34.26265219680964, 0],
                debug: false,
            };
            new map3d.THREEEffect.DirectionLight(directionlightconfig3);
            let directionlightconfig4 = {
                //灯光颜色
                color: `rgba(5,5,5,0.6)`,
                //照射强度
                intensity: 16.6,
                //光源中心位置,格式为[lng,lat,height]
                lightcenter: [109.0763491865336, 34.26265219680964, 0],
                //目标中心位置,格式为[lng,lat,height]
                targetcenter: [108.7836134451926, 34.264255091601676, 0],
                debug: false,
            };
            new map3d.THREEEffect.DirectionLight(directionlightconfig4);
            let directionlightconfig5 = {
                //灯光颜色
                color: `rgba(5,5,5,0.6)`,
                //照射强度
                intensity: 40,
                //光源中心位置,格式为[lng,lat,height]
                lightcenter: [108.93386678647725, 34.26037407318522, 1000],
                //目标中心位置,格式为[lng,lat,height]
                targetcenter: [108.93386678647725, 34.26037407318522, 0],
                debug: false,
            };
            new map3d.THREEEffect.DirectionLight(directionlightconfig5);
        }
    }
    start(rect) {
        const box = rect
        const totolnum = this.num
        const lngstep = (box[2] - box[0]) / Math.sqrt(totolnum, 1 / 2)
        const radius = Math.max(lngstep, lngstep) / 0.00001141
        const latstep = (box[3] - box[1]) / Math.sqrt(totolnum, 1 / 2)
        const coords = []
        for (let i = 0; i < Math.sqrt(totolnum, 1 / 2); i++) {
            for (let j = 0; j < Math.sqrt(totolnum, 1 / 2); j++) {
                const lng = box[0] + i * lngstep
                const lat = box[3] - j * latstep
                coords.push([lng, lat])
            }
        }
        const geojson = {
            "type": "FeatureCollection",
            "features": []
        }
        const t1 = new Cesium.CesiumTerrainProvider(new BasicTerrain(window.digfillConfig[0].url));
        const t2 = new Cesium.CesiumTerrainProvider(new BasicTerrain(window.digfillConfig[1].url));
        map3d.THREEEffect.GeoUtiles.getTerrainHeights(coords, t1, this.level).then((data1) => {
            map3d.THREEEffect.GeoUtiles.getTerrainHeights(coords, t2, this.level).then((data2) => {
                for (let i = 0; i <= data1.length - 3; i += 3) {
                    const h1 = data1[i + 2]
                    const h2 = data2[i + 2]
                    if (h1 !== 0 && h2 !== 0) {
                        const feature = {
                            "type": "Feature",
                            "properties": { "height1": h1, "height2": h2 },
                            "geometry": {
                                "type": "Point",
                                "coordinates": [data1[i], data1[i + 1]]
                            }
                        }
                        geojson.features.push(feature)
                    }
                }
                const part1 = []
                const part2 = []
                geojson.features.forEach((item) => {
                    if (item.properties.height1 > item.properties.height2) {
                        part1.push(item)
                    } else if (item.properties.height1 < item.properties.height2) {
                        part2.push(item)
                    }
                })
                if (part2.length > 0) {
                    let config = {
                        features: part2,
                        //geojson中描述高度的字段名称
                        heightPropName: "height1",
                        startHeightPropName: "height2",
                        //建筑本体颜色,透明度
                        num: 1,
                        opacity: 0.45,
                        radius: radius,
                        //高度夸张系数
                        heightScale: 1,
                        //高度偏移系数
                        heightOffset: 0,
                        //针对物理材质的具体配置
                        reflectivity: 0.1,
                        //颜色
                        color: "#00FF00",
                        speed: 0.005,
                        //动画方向,0为从下到上,1为从上到下
                        direction: 0,
                    }
                    const bh = new map3d.THREEEffect.BarWithVariableHeight(config)
                    bh.ready.then(() => {
                        bh.animation()
                    })
                    this.containers.push(bh)
                }
                if (part1.length > 0) {
                    let config = {
                        features: part1,
                        //geojson中描述高度的字段名称
                        heightPropName: "height1",
                        startHeightPropName: "height2",
                        //建筑本体颜色,透明度
                        num: 1,
                        opacity: 0.45,
                        radius: radius,
                        //高度夸张系数
                        heightScale: 1,
                        //高度偏移系数
                        heightOffset: 0,
                        //针对物理材质的具体配置
                        reflectivity: 0.1,
                        //颜色
                        color: "#ff0000",
                        speed: 0.005,
                        direction: 1,
                    }
                    const bh = new map3d.THREEEffect.BarWithVariableHeight(config)
                    bh.ready.then(() => {
                        bh.animation()
                    })
                    this.containers.push(bh)
                }
            })
        })
    }
    removeAll() {
        this.containers.forEach((item) => {
            item.remove()
        })
        this.containers = []
    }
}
export default new AddBar()




// WEBPACK FOOTER //
// ./src/mapfunction/AddBar.js